<form nz-form [formGroup]="form" (ngSubmit)="onSubmit()" nzLayout="horizontal" class="p-4">
	<div class="modal-body">

		<nz-form-item *ngIf="input.id <= 0">
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="property">Property</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 100 characters',pattern: 'Must start with a letter/underscore and contain only letters, digits, or underscores'}}">
				<input nz-input id="property" formControlName="property" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="name">Name</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 100 characters'}}">
				<input nz-input id="name" formControlName="name" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzFor="description">Description</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 255 characters'}}">
				<input nz-input id="description" formControlName="description" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzFor="bulkImportColumnName">Bulk Upload Column Name</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 255 characters'}}">
				<input nz-input id="bulkImportColumnName" formControlName="bulkImportColumnName" />
			</nz-form-control>
		</nz-form-item>



		<nz-divider nzText="Dependency"></nz-divider>



		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzFor="dependencyId">Depends On</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select formControlName="dependencyId" id="dependencyId">
					<nz-option [nzValue]="undefined" [nzLabel]="'None'"></nz-option>
					<ng-container *ngFor="let item of dynamicEntity.properties">
						<nz-option *ngIf="item.id != input.id" [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
					</ng-container>
				</nz-select>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item *ngIf="hasDependency">
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="dependencyValue">Expected Value</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<input nz-input id="dependencyValue" formControlName="dependencyValue" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item *ngIf="hasDependency">
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="dependencyValueInverted">Inverted</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
				<label nz-checkbox formControlName="dependencyValueInverted">Inverted</label>
			</nz-form-control>
		</nz-form-item>

		<nz-divider nzText="Settings"></nz-divider>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" >Editable</nz-form-label>
			<nz-form-control [nzSpan]="7" [nzAutoTips]="{en: {required: 'Required'}}">
				<label nz-checkbox formControlName="activeOnCreate">Create</label>
			</nz-form-control>
			<nz-form-control [nzSpan]="7" [nzAutoTips]="{en: {required: 'Required'}}">
				<label nz-checkbox formControlName="activeOnUpdate">Modify</label>
			</nz-form-control>
			<nz-form-control [nzSpan]="7" [nzAutoTips]="{en: {required: 'Required'}}">
				<label nz-checkbox formControlName="searchable">Searchable</label>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="dataType">Data Type</nz-form-label>
			<nz-form-control [nzSpan]="14"  [nzAutoTips]="{en: {required: 'Required'}}">
				<nz-select formControlName="dataType" id="dataType">
					<nz-option *ngFor="let d of dataTypes" [nzValue]="d" [nzLabel]="d"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item formArrayName="options" *ngIf="dataType == 'DropDownSingle'">
			<nz-form-label [nzSpan]="6" [nzRequired]="true" >Options</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<div *ngFor="let option of optionForms.controls; let i = index" [formGroupName]="i">
					<div class="row g-1 mb-1">
						<div class="col"><input nz-input placeholder="Value" formControlName="value"/></div>
						<div class="col"><input nz-input placeholder="Label" formControlName="label"/></div>
						<div class="col"><button nz-button nzType="default" nzDanger (click)="removeOption(i)">X</button></div>
					</div>
				</div>
				<button nz-button nzType="dashed" (click)="addOption()">+ Add Option</button>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item nzFor="subDynamic" *ngIf="dataType == 'SetOfRecords' || dataType == 'SelectFromRecords'">
			<nz-form-label [nzSpan]="6" [nzRequired]="true" >Sub Type</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select formControlName="subDynamic" id="subDynamic" [compareWith]="compareSelectValues">
					<ng-container *ngFor="let type of allDynamicEntities">
						<nz-option [nzValue]="type" [nzLabel]="type.entityType"></nz-option>
					</ng-container>
				</nz-select>
			</nz-form-control>
		</nz-form-item>


		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzFor="sectionId" [nzRequired]="true">Template Section</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select formControlName="sectionId" id="sectionId">
					<ng-container *ngFor="let item of dynamicEntity.template.sections">
						<nz-option [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
					</ng-container>
				</nz-select>
			</nz-form-control>
		</nz-form-item>


		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzFor="orderIndex" [nzRequired]="true">Display Index</nz-form-label>
			<nz-form-control [nzSpan]="14"  [nzAutoTips]="{en: {required: 'Required'}}">
				<input nz-input type="number" placeholder="Index" formControlName="orderIndex" />
			</nz-form-control>
		</nz-form-item>

		<nz-form-item nz-tooltip="Font Awesome 6 (free)">
			<nz-form-label [nzSpan]="6" nzFor="icon">Icon</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-input-group [nzSuffix]="suffixIcon">
					<input nz-input type="text" placeholder="Index" formControlName="icon" />
				</nz-input-group>

				<ng-template #suffixIcon>
					<span *ngIf="icon">
						Preview:
						<fa-icon *ngIf="icon" [icon]="['fas', icon]"></fa-icon>
					</span>
				</ng-template>
			</nz-form-control>
		</nz-form-item>

		<nz-divider nzText="Validations"></nz-divider>
		<nz-form-item>
			<nz-form-label [nzSpan]="6">Required</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required', maxLength: 'Cannot exceed 255 characters'}}">
				<div class="flex flex-col gap-2">
					<label nz-checkbox formControlName="required">Required</label>
					<input nz-input placeholder="Required error message" formControlName="errorMessageRequired" />
				</div>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6">Unique</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required', maxLength: 'Cannot exceed 255 characters'}}">
				<div class="flex flex-col gap-2">
					<label nz-checkbox formControlName="isUnique">Unique</label>
					<input nz-input placeholder="Unique error message" formControlName="errorMessageUnique" />
				</div>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item>
			<nz-form-label [nzSpan]="6">Pattern</nz-form-label>
			<nz-form-control [nzSpan]="7">
				<input nz-input placeholder="Regex Pattern" formControlName="regex" />
			</nz-form-control>
			<nz-form-control [nzSpan]="7">
				<input nz-input placeholder="Pattern error message" formControlName="errorMessageRegex" />
			</nz-form-control>
		</nz-form-item>


		<nz-form-item>
			<nz-form-label [nzSpan]="6">Min</nz-form-label>
			<nz-form-control [nzSpan]="7"  [nzAutoTips]="{en: {pattern: 'must be a number valid'}}">
				<input nz-input type="number" placeholder="Min" formControlName="minValue" />
			</nz-form-control>
			<nz-form-control [nzSpan]="7">
				<input nz-input placeholder="Min value error" formControlName="errorMessageMinValue" />
			</nz-form-control>
		</nz-form-item>



		<nz-form-item>
			<nz-form-label [nzSpan]="6">Max</nz-form-label>
			<nz-form-control [nzSpan]="7"  [nzAutoTips]="{en: {pattern: 'must be a number valid'}}">
				<input nz-input type="number" placeholder="Max" formControlName="maxValue" />
			</nz-form-control>
			<nz-form-control [nzSpan]="7">
				<input nz-input placeholder="Max value error" formControlName="errorMessageMaxValue" />
			</nz-form-control>
		</nz-form-item>

	</div>
	<div class="modal-footer" style="text-align: right;">
		<nz-form-item>
			<nz-form-control>
				<button class="me-1" nz-button nzType="default" (click)="doCancel()">Cancel</button>
				<button nz-button nzType="primary" *ngIf="form.valid" (click)="doSave()">Save</button>
				<button
					*ngIf="!form.valid"
					nz-button
					nzType="default"
					nz-tooltip
					[nzTooltipTitle]="titleTemplate"
					(click)="doTouchAllFields(form)" >
					Save
				</button>

				<button
					class="ms-3"
					*ngIf="input.id > 0 && input.type == 'Dynamic'"
					nz-button
					nzType="default"
					nzDanger
					(click)="doDelete()" >
					Delete
				</button>
			</nz-form-control>
		</nz-form-item>
	</div>

    <ng-template #titleTemplate let-thing>
		<ul>
			<li *ngFor="let item of getInvalidControlsList(form)">
				<b>{{item.field}}: </b>
				{{item. errors}}
			</li>
		</ul>
    </ng-template>

</form>
